import React from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

import { SeoHelper } from "../../components/helpers/SeoHelper";

class PrivacyPolicy extends React.Component {

  render() {
    return (
        <>
          <SeoHelper
              uri="/privacy-policy"
              title = "Privacy Policy | The Worship Bible"
              description="This Privacy Policy explains how The Worship Bible collects, uses, and protects your personal data."
          />

          {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>privacy policy</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>


          {/* Content */}
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Card className="shadow border-0">
                    <CardBody className="py-5 terms-content">

                      <h2
                          style={{ fontSize: "1rem" }}
                          className="text-primary text-uppercase pt-3 pb-3"
                      >
                        Privacy Policy
                      </h2>

                      <p><strong>The Worship Bible</strong></p>
                      <p><strong>Last updated: 7 February 2026</strong></p>

                      <hr />

                      <p>
                        This Privacy Notice for The Worship Bible (“we”, “us”, or “our”)
                        explains how and why we collect, store, use, and share (“process”)
                        personal information when you use our services (“Services”).
                      </p>

                      <p>You may use our Services when you:</p>
                      <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal">
                        <li>Visit or use our website at <a
                            href="https://theworshipbible.church">theworshipbible.church</a></li>
                        <li>Register for an account or use platform features</li>
                        <li>Contact us for support, information, or updates</li>
                      </ul>

                      <p>
                        If you do not agree with this Privacy Notice, please do not use our Services.
                        Questions can be sent to{" "}
                        <a href="mailto:info@theworshipbible.church">info@theworshipbible.church</a>.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        Summary of Key Points
                      </h3>

                      <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal">
                        <li>We collect only limited personal data needed to operate the platform</li>
                        <li>We do not process sensitive personal data</li>
                        <li>We do not sell personal data</li>
                        <li>We use appropriate security and access controls</li>
                        <li>You have rights to access, correct, or delete your data</li>
                      </ul>

                      <h3 className="MsoNormal text-primary" style={{fontSize: "1rem"}}>
                      1. Information We Collect
                      </h3>

                      <p>We may collect the following information when you use the Services:</p>
                      <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal">
                        <li>Name and email address</li>
                        <li>Encrypted password</li>
                        <li>Account and subscription information</li>
                        <li>User-generated content such as playlists or song-flows</li>
                      </ul>

                      <p>
                        We do not collect or process sensitive personal data.
                      </p>

                      <p>
                        Payments are handled securely by Stripe, Inc. We do not store or process
                        card details. Stripe’s privacy notice is available at{" "}
                        <a href="https://stripe.com/gb/privacy" target="_blank" rel="noreferrer">
                          stripe.com/gb/privacy
                        </a>.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        2. How We Use Your Information
                      </h3>

                      <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal">
                        <li>To create and manage user accounts</li>
                        <li>To provide and improve platform features</li>
                        <li>To communicate service-related messages</li>
                        <li>To protect users and systems from misuse</li>
                        <li>To comply with legal obligations</li>
                      </ul>

                      <h3 className="MsoNormal text-primary" style={{fontSize: "1rem"}}>
                      3. Legal Bases for Processing
                      </h3>

                      <p>
                        Under UK GDPR and EU GDPR, we rely on contract performance,
                        legitimate interests, legal obligations, and consent (where applicable).
                        Consent may be withdrawn at any time by contacting{" "}
                        <a href="mailto:admin@theworshipbible.church">admin@theworshipbible.church</a>.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        4. Data Sharing
                      </h3>

                      <p>
                        We may share data only with essential service providers,
                        legal authorities where required, or successor organisations
                        in the event of a business transfer. We do not sell personal data.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        5. Cookies & Analytics
                      </h3>

                      <p>
                        We use cookies for essential functionality, security, and basic analytics.
                        Google Analytics may be used to understand platform usage.
                        You can opt out at{" "}
                        <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer">
                          tools.google.com/dlpage/gaoptout
                        </a>.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        6. Data Retention
                      </h3>

                      <p>
                        Personal data is retained only as long as necessary.
                        Account data is typically kept for up to 12 months after closure
                        unless required by law.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        7. Security
                      </h3>

                      <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal">
                        <li>HTTPS encryption</li>
                        <li>Secure password hashing</li>
                        <li>Restricted administrative access</li>
                        <li>Monitoring and logging</li>
                        <li>Regular security updates</li>
                      </ul>

                      <h3 className="MsoNormal text-primary" style={{fontSize: "1rem"}}>
                      8. Children’s Data
                      </h3>

                      <p>
                        The Services are not intended for children under 18.
                        We do not knowingly collect data from minors.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        9. Your Rights
                      </h3>

                      <p>
                        Depending on your location, you may have rights to access,
                        correct, delete, or restrict processing of your personal data.
                        Requests can be made by contacting{" "}
                        <a href="mailto:admin@theworshipbible.church">admin@theworshipbible.church</a>.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        10. Updates
                      </h3>

                      <p>
                        We may update this Privacy Policy from time to time.
                        Material changes will be communicated via the website or email.
                      </p>

                      <h3 className="MsoNormal text-primary" style={{ fontSize: "1rem" }}>
                        11. Contact & Data Controller
                      </h3>

                      <p>
                        <strong>The Worship Bible</strong><br />
                        United Kingdom
                      </p>

                      <p>
                        Data Protection Officer:<br />
                        Stephen Jewitt<br />
                        <a href="mailto:admin@theworshipbible.church">
                          admin@theworshipbible.church
                        </a>
                      </p>

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </>
    );
  }
}

export default PrivacyPolicy;